import BaseListPage from "../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import { getCurrentUserUseCase } from "../../usecases/user";
import { InfiniteScroll } from "../../nq-component";
import PageHeader from "../../components/PageHeader";
import DatesFilter from "../../components/DatesFilter";
import ReportsListPagePresenter from "./ReportsListPagePresenter";
import CollapseDetails from "./components/CollapseDetails";
import FullPageLoader from "../../components/FullPageLoader";
import ContainerTable from "./components/ContainerTable";
import {
  exportPurchaseReportUseCase,
  exportSalesReportUseCase,
  exportXLSXUseCase,
} from "../../usecases/xlsx";
import withRouter from "../../withRouter";
import InputFactory from "../../components/InputFactory";
import ClientFilter from "../../components/ClientFilter";

class ReportsListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      category: "Quarterly",
      year: new Date().getFullYear(),
      month: new Date().toLocaleString("default", { month: "long" }) || "",
      biYear: "",
      yearly: "",
      objects: [],
      allObjects: [],
      query: {},
      half: "1st Half",
      quarter: "1st Quarter",
      pageProgress: false,
      collection: "sales",
      clientProgress: false,
    };
    this.presenter = new ReportsListPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      getCurrentUserUseCase(),
      exportXLSXUseCase(),
      exportPurchaseReportUseCase(),
      exportSalesReportUseCase(),
    );
  }

  async componentDidMount() {
    await this.presenter.componentDidMount();
  }

  getCollectionName() {
    const { collection } = this.state;
    return collection;
  }

  getStorageKey() {
    return "selected_client";
  }

  //Getting the already selected client from session storage
  getSelectedClient() {
    const storageKey = this.getStorageKey();
    return JSON.parse(sessionStorage.getItem(storageKey));
  }

  getClientId() {
    return this.props.params.id;
  }

  getMonths() {
    const { year } = this.state;

    const months = Array.from({ length: 12 }, (_, i) => {
      return new Intl.DateTimeFormat("en-US", { month: "long" }).format(
        new Date(year, i, 1),
      );
    });

    return months;
  }

  getObjects() {
    this.presenter.getObjects();
  }

  showClientProgress() {
    this.setState({ clientProgress: true });
  }

  hideClientProgress() {
    this.setState({ clientProgress: false });
  }

  onFilter() {
    this.presenter.init();
    this.presenter.getObjects();
  }

  onChange(value, field) {
    this.setState(value);
  }

  showPageProgress() {
    this.setState({ pageProgress: true });
  }

  hidePageProgress() {
    this.setState({ pageProgress: false });
  }

  onCollapse(index, object) {
    return (
      <CollapseDetails
        object={object}
        // onDelete={this.onDeleteModal.bind(this)}
        // onEdit={this.onEdit.bind(this)}
      />
    );
  }

  async onExportCSV(collection, objects) {
    return this.presenter.accountantReport(collection, objects);
  }

  onFilter(e) {
    e.preventDefault();
    this.presenter.init();
    this.presenter.getObjects();
  }

  onChangeFilter(value, field) {
    this.setState({ [field]: value });
  }

  onChangeTab(value, field) {
    this.setState({ collection: value }, () => {
      this.presenter.init();
      this.getObjects();
    });
  }

  onChangeClient(value, field) {
    const storageKey = this.getStorageKey();
    sessionStorage.setItem(storageKey, JSON.stringify(value));
    this.presenter.onChangeClient();
  }

  clientFilter() {
    const collection = this.getCollectionName();
    const schema = this.getSchema(collection);
    const schemas = this.getSchemas();
    const user = this.getCurrentUser();
    const selectedClient = this.getSelectedClient();
    const { clientProgress } = this.state;

    return (
      <ClientFilter
        type="Pointer"
        target={"clients"}
        object={{ selectedClient }}
        className="bg-light border-1 border-primary"
        placeholder="Select Client"
        field="selectedClient"
        indexes={["name", "billingCity"]}
        keys={["id", "name", "user", "billingCity"]}
        actionButton={false}
        progress={clientProgress}
        where={{
          $and: [
            { creator: { id: user?.id } },
            { isActive: true },
            { clientOf: "admin" },
          ],
        }}
        schema={schema}
        schemas={schemas}
        onChange={this.onChangeClient.bind(this)}
        required
      />
    );
  }

  render() {
    const {
      progress,
      category,
      year,
      month,
      objects,
      quarter,
      half,
      selected,
      pageProgress,
      count,
      collection,
    } = this.state;
    const months = this.getMonths();

    const yearToNumber = Number(year);
    const schemaPurchases = this.getSchema("purchases");
    const schemaSales = this.getSchema("sales");
    const schema = collection === "sales" ? schemaSales : schemaPurchases;
    const isAdmin = this.isAdmin();
    const collectionName = this.getCollectionName();

    const displayObjects = objects;
    return (
      <>
        <InfiniteScroll className="p-3 p-xl-4 overflow-auto">
          <div className="d-flex flex-column gap-4">
            <PageHeader
              breadcrumb={[{ label: "Home", path: "/" }, { label: "Reports" }]}
              selected={selected}
              objects={displayObjects}
              title={`Reports`}
              backButton={isAdmin}
              action={isAdmin && this.clientFilter.bind(this)}
            />

            <form
              onSubmit={this.onFilter.bind(this)}
              className="d-flex flex-column gap-4"
            >
              {/* Filters Card */}
              <DatesFilter
                variant="card"
                title="Filter by date"
                category={category}
                year={yearToNumber}
                month={month}
                months={months}
                quarter={quarter}
                half={half}
                onChangeFilter={this.onChangeFilter.bind(this)}
                onFilter={() => {
                  this.presenter.init();
                  this.getObjects();
                }}
              />

              {/* Table Container Card */}
              <div
                className="bg-white rounded-3 shadow-sm"
                style={{
                  border: "1px solid #e9ecef",
                  overflow: "hidden",
                }}
              >
                <ContainerTable
                  schema={schema}
                  onSort={this.onClickSort.bind(this)}
                  title="Purchases"
                  selected={selected}
                  objects={displayObjects}
                  purchasesSchema={schemaPurchases}
                  salesSchema={schemaSales}
                  onExport={this.onExportCSV.bind(this)}
                  progress={progress}
                  count={count}
                  collectionName={collection}
                  onChangeTab={this.onChangeTab.bind(this)}
                />
              </div>
            </form>
          </div>
        </InfiniteScroll>
        {pageProgress && <FullPageLoader />}
      </>
    );
  }
}

export default withRouter(ReportsListPage);
